module.exports = __webpack_public_path__ + "static/media/made-in-the-usa.e12a9a1a.png";